module.exports = __webpack_public_path__ + "img/lesson-manage.c507b989.svg";